/*
 * @Description: 业务员管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2021-07-06 18:32:16
 * @LastEditTime: 2023-07-12 16:04:23
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 审核列表
  salesmanList (querys) {
    return get('massage/admin/AdminSalesman/salesmanList', querys)
  },
  // 业务员详情
  salesmanInfo (querys) {
    return get('massage/admin/AdminSalesman/salesmanInfo', querys)
  },
  // 修改业务员
  salesmanUpdate (querys) {
    return post('massage/admin/AdminSalesman/salesmanUpdate', querys)
  },
  // 审核业务员
  checkSalesman (querys) {
    return post('massage/admin/AdminSalesman/checkSalesman', querys)
  },
  // 数据统计
  salesmanDataList (querys) {
    return get('massage/admin/AdminSalesman/salesmanDataList', querys)
  },
  // 设置提成比例
  setSalesmanBalance (querys) {
    return post('massage/admin/AdminSalesman/setSalesmanBalance', querys)
  },
  // 删除提成比例
  delSalesmanBalance (querys) {
    return post('massage/admin/AdminSalesman/delSalesmanBalance', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/salesman.js